import { InputAdornment, TextField, Box } from '@mui/material';
import { InputStyle } from 'components/InitialStyle';
import CustomLabel from 'components/customLabel';
import React from 'react';
import { Controller } from 'react-hook-form';

const EmailInput = ({
  label,
  icon,
  iconStart,
  fullWidth,
  name,
  control,
  error,
  placeholder,
  disabled,
}) => {
  return (
    <Box style={{ width: '100%' }}>
      {label ? <CustomLabel>{label}</CustomLabel> : undefined}

      <Controller
        name={name}
        control={control}
        rules={{
          required: 'Поле, обязательное для заполнения',
          validate: {
            isEmail: (value) =>
              /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ||
              'Неверный формат email',
            isStrictLatinEmail: (value) => {
              // Kiril harflarini tekshirish (rus, ukrain, belarus va boshqa kiril harflari)
              const hasCyrillicChars = /[а-яёА-ЯЁ]/.test(value);
              if (hasCyrillicChars) {
                return 'Только латинские буквы разрешены в email';
              }

              // Boshqa ASCII bo'lmagan belgilarni tekshirish
              const hasOnlyASCII = Array.from(value).every(
                (ch) => ch.charCodeAt(0) <= 0x7f
              );
              if (!hasOnlyASCII) {
                return 'Только латинские буквы разрешены в email';
              }

              // Email formatini tekshirish
              const isValidLatinEmail =
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
              return isValidLatinEmail || 'Неверный формат email';
            },
          },
        }}
        render={({ field }) => (
          <TextField
            autoComplete='off'
            disabled={disabled}
            {...field}
            type='email'
            placeholder={placeholder}
            value={field.value || ''}
            fullWidth={fullWidth}
            sx={{
              ...InputStyle,
              '.Mui-disabled': {
                overflow: 'hidden',
                borderColor: '#D0D0D0',
              },
              '.MuiInputBase-input': {
                padding: iconStart ? '10px 0px' : '10px 12px',
                fontFamily: 'SF Pro Display',
                fontSize: '14px',
                lineHeight: '20px',
              },
              '.MuiInputAdornment-root ': { marginRight: '0' },
            }}
            onWheel={(e) => e.target.blur()}
            error={Boolean(error?.[name]) || Boolean(error?.message)}
            InputProps={{
              inputProps: { min: 0 },
              endAdornment: (
                <InputAdornment position='end'>{icon}</InputAdornment>
              ),
              startAdornment: iconStart && (
                <InputAdornment
                  style={{ width: '20px', color: 'black', fontSize: '14px' }}
                  position='start'
                >
                  {iconStart}
                </InputAdornment>
              ),
            }}
          />
        )}
      />

      {error?.[name]?.type === 'required' && (
        <small style={{ color: 'red', fontSize: '11px' }}>
          {error[name].message}
        </small>
      )}

      {error?.[name]?.type === 'isEmail' && (
        <small style={{ color: 'red', fontSize: '11px' }}>
          {error[name].message}
        </small>
      )}
      {error?.[name]?.type === 'isStrictLatinEmail' && (
        <small style={{ color: 'red', fontSize: '11px' }}>
          {error[name].message}
        </small>
      )}

      {error?.type === 'required' && (
        <small style={{ color: 'red', fontSize: '11px' }}>
          {error?.message}
        </small>
      )}
    </Box>
  );
};

export default EmailInput;
